<template>
  <div class="everyday" id="everyday">
    <div class="top">
      <div class="back" @click="back">
        <i class="el-icon-arrow-left" /> 返回
      </div>
      <div class="path">
        <i class="el-icon-location" /> 首页-待办日常
      </div>
    </div>

    <div class="everydaycont">
      <el-tabs @tab-click="activechange" v-model="activeName">
        <el-tab-pane label="日常会议" name="conference">
          <div class="additionbtn">
            <el-button size="mini" icon="el-icon-plus" @click="addition">添加</el-button>
          </div>
          <Conference />
        </el-tab-pane>
        <el-tab-pane label="紧急事宜" name="concerned">
          <Concerned />
        </el-tab-pane>
        <el-tab-pane label="日常工作" name="work">
          <Work />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>


<script>
import Conference from "./conference";
import Concerned from "./concerned";
import Work from "./work";
import { localStorageUtil } from "@/utils/storage";
export default {
  name: "everyday",
  components: {
    Conference,
    Concerned,
    Work,
  },
  data() {
    console.log(
      "88888888888888888888888",
      localStorageUtil.getValue("everyday_type")
    );
    return {
      activeName: localStorageUtil.getValue("everyday_type")
        ? localStorageUtil.getValue("everyday_type")
        : "conference",
    };
  },
  methods: {
    back() {
      this.$router.push({ name: "HomePage" });
    },
    addition() {
      console.log(1);
      this.$router.push({ name: "sponsor" });
    },
    activechange(tab, e) {
      console.log(tab.name, e);
      this.activeName = tab.name;
      localStorageUtil.save("everyday_type", tab.name);
    },
  },
};
</script>

<style lang="less" scoped>
.everyday {
  background-color: #f5f6fd;
  padding: 17px 19px;
  height: calc(100vh - 100px);
  width: 100%;

  .top {
    height: 49px;
    background: white;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    color: #99a9ba;
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    box-shadow: 0px 6px 14px 0px rgba(127, 170, 217, 0.12);
    .back {
      margin-left: 19px;
      margin-top: 15px;
      display: inline-block;
      cursor: pointer;
    }
    .path {
      margin-left: 19px;
      margin-top: 15px;
      display: inline-block;
    }
  }
  .everydaycont {
    height: calc(100vh - 195px);
    margin-top: 9px;
    background: white;
    font-size: 12px;
    font-family: PingFangSC, PingFangSC-Regular;
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    box-shadow: 0px 6px 14px 0px rgba(127, 170, 217, 0.12);
    padding: 18px 20px;
    .additionbtn {
      position: absolute;
      right: 0px;
      top: -55px;
    }
  }
}
</style>
